import { Box, Typography } from '@mui/material';

const AdminDashboard = () => {
 return (
  <Box className="p-4">
   <Typography variant="h5">Admin Dashboard</Typography>
  </Box>
 );
};

export default AdminDashboard;

